import React from "react";
import styles from "./GalleryAmigurumis.module.css";
import random1 from "../data/assets/Flores/girasol/girasol-1.png";
import random2 from "../data/assets/Flores/lavanda/lavanda-1.png";
import random3 from "../data/assets/Flores/tulipan/tulipan-1.png";

function GalleryRandom() {
  const data = [random1, random2, random3];
  return (
    <div className={styles.container}>
      <h2 className={styles.title}>Detalles en crochet</h2>
      <div className={styles.gallery}>
        {data.map((item, i) => (
          <figure className={styles.item} key={i}>
            <img src={item} alt="foto" className={styles.image}></img>
          </figure>
        ))}{" "}
      </div>
    </div>
  );
}

export { GalleryRandom };
